import React from 'react';
import renderHTML from 'react-render-html';
import './summary-details.css';

const SummaryDetails = (props) => {
  const { summaryTitle, summaryText, customHeadingClass, customDescriptionClass } = props;
  return (
    <div className="row">
      <div className="summary-detail col pl-sm-0">
        <h2 id="summary-heading" className={customHeadingClass ? `${customHeadingClass}` : 'summary-heading'}>{summaryTitle}</h2>
        {summaryText && (<div
          id="summary-description"
          className={customDescriptionClass ? `${customDescriptionClass}` : 'summary-description'}
        >{renderHTML(summaryText)}</div>)}
      </div>
    </div>
  );
};

export default SummaryDetails;
